import { render, staticRenderFns } from "./GitLabIssues.vue?vue&type=template&id=9dc343c6&"
import script from "./GitLabIssues.vue?vue&type=script&lang=js&"
export * from "./GitLabIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports